import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { map, type Observable, of } from 'rxjs';

import { environment } from '@env';

import { API_PATHS } from '@kernel';

import { HTTP_CONTEXT_SKIP_ERROR_TOAST } from '@core/http';

import { createNotificationsMock } from './notifications.mock';
import { type Notifications } from './notifications.types';

@Injectable({ providedIn: 'root' })
export class NotificationsService {
  private readonly http = inject(HttpClient);

  getNotifications(): Observable<readonly Notifications[]> {
    if (environment.useMocks) return of(createNotificationsMock());

    return this.http
      .get<readonly Notifications[]>(`${environment.apiUrl}${API_PATHS.notifications}`, {
        context: HTTP_CONTEXT_SKIP_ERROR_TOAST,
      })
      .pipe(map((rows) => rows ?? []));
  }

  openedNotification(notificationId: number): Observable<void> {
    if (environment.useMocks) return of(undefined);

    return this.http.put<void>(
      `${environment.apiUrl}${API_PATHS.notifications}/${notificationId}/opened`,
      null,
      { context: HTTP_CONTEXT_SKIP_ERROR_TOAST },
    );
  }
}
